

// import { Loading } from '@mbfab/client-common' // TODO
import { StyleProvider } from '@ant-design/cssinjs'
import { Auth0Provider } from '@auth0/auth0-react'
import { ConfigProvider } from 'antd'
import ja_JP from 'antd/lib/locale/ja_JP'
import { Suspense, useEffect, useState } from 'react'

import { envVariables } from '../../lib/env'

// hydrationを無効化する
const SafeHydrate: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const [visibility, setVisibility] = useState(false)
  useEffect(() => {
    setVisibility(true)
  }, [])

  if (!visibility) {
    return <></>
  }

  return <>{typeof window === 'undefined' ? null : children}</>
}

export const DefaultProvider = ({ children }: { children: React.ReactElement }) => {
  return (
    <SafeHydrate>
      {/* TODO fallback */}
      <Suspense>
        <Auth0Provider
          domain={envVariables.AUTH0_DOMAIN}
          clientId={envVariables.AUTH0_SPA_APP_CLIENT_ID}
          authorizationParams={{
            redirect_uri: window.location.origin,
          }}
        >
          <StyleProvider layer>
            <ConfigProvider
              locale={ja_JP}
              theme={{
                token: {
                  colorPrimary: `#2196F3`,
                  borderRadius: 6,
                  colorBgLayout: `#FFFFFF`,
                  fontFamily: [
                    `-apple-system`,
                    'system-ui',
                    'Segoe UI',
                    `roboto`,
                    'Helvetica Neue',
                    `helvetica`,
                    `arial`,
                    `sans-serif`,
                  ].join(', '),
                  // colorBgBase: `#FDFEFF`,
                  // 'table-body-sort-bg': '#FEFBEA', // bg-yellow-100
                  // 'table-row-hover-bg': 'white',
                  // // "table-padding-horizontal": "8px",
                  // // "table-padding-vertical": "8px",
                },
              }}
            >
              {children}
            </ConfigProvider>
          </StyleProvider>
        </Auth0Provider>
      </Suspense>
    </SafeHydrate>
  )
}
